const SENTRY = {
  CATEGORIES: {
    FORM: 'FORM',
    ORDERS: 'ORDERS',
    PRODUCT: 'PRODUCT',
    PRICES: 'PRICES',
    CART: 'CART',
    LOGIN: 'LOGIN',
    ARTICLE: 'ARTICLE',
    ACCOUNT: 'ACCOUNT',
  }
};

export default SENTRY;


// WEBPACK FOOTER //
// ./src/scripts/src/custom/sentry.js